import { useEffect } from 'react';
import { CuredApiPaths } from 'models/enums';
import Card from 'pages/InsightsPage/dashboards/Card';
import { FiltersForApiState } from 'pages/InsightsPage/dashboards/filtering/types';
import useFilteredData from 'pages/InsightsPage/dashboards/filtering/useFilteredData';
import LineGraph from 'pages/InsightsPage/visualizations/LineGraph';
import CustomTooltip from 'pages/InsightsPage/visualizations/CustomTooltip';

type Props = {
    filtersForApi: FiltersForApiState;
};

const NewSubsOverTimeCard = ({ filtersForApi }: Props) => {
    const { getData, isError, isLoading, data } = useFilteredData({
        key: 'sms-dashboard/subscribes',
        path: CuredApiPaths.REPORT_SMS_SUBSCRIBES,
    });

    useEffect(() => {
        getData(filtersForApi);
    }, [filtersForApi, getData]);

    const renderCustomTooltip = (point: any) => (
        <CustomTooltip
            color={point.serieColor}
            label={`subscribe date - ${point.data.xFormatted}`}
            value={`subscriber count - ${point.data.yFormatted}`}
        />
    );

    return (
        <Card isError={isError} isLoading={isLoading} label="New Text Message Subscribers over Time">
            <LineGraph data={[data]} leftLegendLabel="new subscribers" renderCustomTooltip={renderCustomTooltip} />
        </Card>
    );
};

export default NewSubsOverTimeCard;
